import React from "react";
import { motion } from "framer-motion";
import FooterOne from "../common/footer/FooterOne";
import HeaderOne from "../common/header/HeaderOne";
import SEO from "../common/SEO";
import AboutOne from "../component/about/AboutOne";
import CounterUpOne from "../component/counterup/CounterUpOne";
import ProjectOne from "../component/project/ProjectOne";
import ServicePropOne from "../component/service/ServicePropOne";
import TestimonialOne from "../component/testimonial/TestimonialOne";
import SectionTitle from "../elements/section-title/SectionTitle";
import Certificate from "../component/certificate/Certificate";
import SectionTitle1 from "../elements/section-title/SectionTitle1";
import ClientSlider from "../component/client/ClientSlider";
import BannerNew from "../component/banner/BannerNew";
  
const Home = () => {
  return ( 
    <>
      <SEO title="Home" />
  
      <main className="main-wrapper">
        <HeaderOne />  
        <BannerNew />
        <AboutOne />
    
        <div className="section section-padding-2 bg-color-dark">
          <div className="container"> 
            <SectionTitle1
              subtitle="What We Can Do For You"
              title="Services we can help you with"
              description=""
              textAlignment="heading-light-left"
              textColor=""
            />
            <motion.div
              className="row"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              transition={{ staggerChildren: 0.1 }}
            >
              <ServicePropOne
                colSize="col-xl-3 col-md-6"
                serviceStyle=""
                itemShow="5"
              />
            </motion.div>
          </div>
        </div>

        <ProjectOne
          subtitle="Our Expertise"
          title="Where we do"
          isHomePage={true}
        />

        <div className="container">
          <SectionTitle
            subtitle="Our Clients"
            title="Our valued partners"
            textAlignment="heading-left mb--40"
            textColor=""
          />
        </div>

        <ClientSlider
          itemShow={4}
          colSize="col-md-3"
          columnGap="row-35"
          parentClass="your-custom-class"
        />

        <CounterUpOne />
        <TestimonialOne />

        <Certificate />

        <FooterOne parentClass="" />
      </main>
    </>
  );
};

export default Home;
